export const addQueueBigSnack = ({ commit }, payload) => {
  commit('ADD_QUEUE_BIG_SNACK', payload)
}

export const removeFirstSnack = ({ commit }, payload) => {
  commit('REMOVE_FIRST_ITEM', payload)
}

export const setDisclaimer = ({ commit }, payload) => {
  commit('SET_DISCLAIMER', payload)
}
export const addDisclaimer = ({ commit }, payload) => {
  commit('ADD_DISCLAIMER', payload)
}
export const setDisclaimerLoading = ({ commit }, payload) => {
  commit('SET_DISCLAIMER_LOADING', payload)
}
export const setOfficeParameters = ({ commit }, payload) => {
  commit('SET_OFFICE_PARAMETERS', payload)
}
export const addOfficeParameters = ({ commit }, payload) => {
  commit('ADD_OFFICE_PARAMETERS', payload)
}
export const setOfficeParametersLoading = ({ commit }, payload) => {
  commit('SET_OFFICE_PARAMETERS_LOADING', payload)
}

export const setProfissionaisPermissao = ({ commit }, payload) => {
  commit('SET_PROFISSIONAIS_PERMISSAO', payload)
}
export const addProfissionaisPermissao = ({ commit }, payload) => {
  commit('ADD_PROFISSIONAIS_PERMISSAO', payload)
}
export const setProfissionaisPermissaoLoading = ({ commit }, payload) => {
  commit('SET_PROFISSIONAIS_PERMISSAO_LOADING', payload)
}

export const setInternalUsers = ({ commit }, payload) => {
  commit('SET_INTERNAL_USERS', payload)
}
export const addInternalUsers = ({ commit }, payload) => {
  commit('ADD_INTERNAL_USERS', payload)
}
export const setInternalUsersLoading = ({ commit }, payload) => {
  commit('SET_INTERNAL_USERS_LOADING', payload)
}

export const setPreviousPage = ({ commit }, payload) => {
  commit('SET_PREVIOUS_PAGE', payload)
}
export const setFullDataClient = ({ commit }, payload) => {
  commit('SET_FULL_DATA_CLIENT', payload)
}
export const addFullDataClient = ({ commit }, payload) => {
  commit('ADD_FULL_DATA_CLIENT', payload)
}
export const setFullDataClientLoading = ({ commit }, payload) => {
  commit('SET_FULL_DATA_CLIENT_LOADING', payload)
}
